import React from 'react';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { useForm } from 'react-hook-form';
import FilterModal from '../../../components/ModernFilters/FilterModal';
import RadioList from '../../../components/ModernFilters/RadioList';
import PeriodSelector from '../../../components/ModernFilters/PeriodSelector';
import { translate } from '../../../services/translate';
import { CamerasParamList } from '../../../typings/Params';
import VideoAnalysisRequesterList from './VideoAnalysisRequesterList';

interface Props {
    filters: CamerasParamList['VideoAnalysis'];
    setFilters: React.Dispatch<React.SetStateAction<CamerasParamList['VideoAnalysis']>>;
    textFilter: string;
    setTextFilter: React.Dispatch<React.SetStateAction<string>>;
}

type FiltersForm = {
    requesterUserId: number | null;
    status: VideoAnalysisStatus | null;
    requestedBetween: {
        from: Date | null;
        to: Date | null;
    };
};

function Filter({ filters, setFilters, textFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<CamerasParamList, 'VideoAnalysis'>>>();
    const form = useForm<FiltersForm>({
        mode: 'onChange',
        defaultValues: {
            requesterUserId: filters.requesterUserId ?? null,
            status: filters.status as VideoAnalysisStatus ?? null,
            requestedBetween: {
                from: filters.startDate ? new Date(filters.startDate) : null,
                to: filters.endDate ? new Date(filters.endDate) : null,
            },
        },
    });

    const handleFilter = (values: FiltersForm) => {
        const params = {
            requesterUserId: values.requesterUserId ?? undefined,
            status: values.status ?? undefined,
            startDate: values.requestedBetween.from?.getTime(),
            endDate: values.requestedBetween.to?.getTime(),
            textFilter: textFilter !== '' ? textFilter : undefined,
        };

        navigation.setParams({ ...filters, page: 1, ...params });
        setFilters({ ...filters, page: 0, ...params });
    };

    return <FilterModal
        form={form}
        onFilters={handleFilter}
        cleanValues={{
            requesterUserId: null,
            status: null,
            requestedBetween: { from: null, to: null },
        }}
        filters={[{
            label: translate('videoAnalysis'),
            filters: [{
                componentHandlesCount: false,
                name: 'status',
                label: translate('status'),
                getCount: RadioList.getCount,
                component: ({ name }) => <RadioList name={name} clearValue={null} items={[
                    { label: translate('failed'), value: 'failed' },
                    { label: translate('pending'), value: 'pending' },
                    { label: translate('success'), value: 'success' },
                ]} />,
            }, {
                componentHandlesCount: false,
                name: 'requesterUserId',
                label: translate('requester'),
                getCount: RadioList.getCount,
                component: VideoAnalysisRequesterList,
            }, {
                componentHandlesCount: true,
                name: 'requestedBetween',
                label: translate('requestedBetween'),
                component: PeriodSelector,
            }],
        }]}
    />;
}

export default Filter;
